import Joi from 'joi';

export const CreatePartnerSchema = Joi.object({
  entityName: Joi.string().trim().min(1).max(64).required().messages({
    'any.required': 'Partner name is required.',
    'string.base': 'Partner name is invalid.',
    'string.empty': 'Partner name is invalid.',
    'string.min': 'Partner name can be at most 64 characters only.',
    'string.max': 'Partner name can be at most 64 characters only.',
  }),
  email: Joi.string().trim().max(100).required().messages({
    'any.required': 'Email is required.',
    'string.base': 'Email is invalid.',
    'string.empty': 'Email is invalid.',
    'string.min': 'Email must have at most 100 characters only.',
    'string.max': 'Email must have at most 100 characters only.',
  }),
  MDR: Joi.number().precision(2).messages({
    'any.required': 'MDR is required.',
    'number.base': 'MDR must be a decimal',
    'number.precision': 'MDR must have only 2 decimal places',
  }),
});
